import type { LeafletTabData } from '@/views/dashboard/components/AddEditLeafletDialog/domain/leaflet-form.types'

import { copyTab, type CreationTask, hasFiles } from './creationTask'

export function applyTaskChanges(task: CreationTask, tab: LeafletTabData) {
  if (task.steps.upload !== 'done' && !tab.pdfURL && !tab.imagesURLPattern && !hasFiles(tab.fileList)) {
    throw new Error('filesRequired')
  }
  if (task.steps.cover !== 'done' && task.tab.firstPageFile.length && !hasFiles(tab.firstPageFile)) {
    throw new Error('filesRequired')
  }
  const previous = task.tab
  task.tab = copyTab(tab)
  task.tab.id = task.leafletId
  if (task.leafletId) task.steps.update = 'pending'
  if (
    JSON.stringify(previous.scheduledLongLink) !== JSON.stringify(tab.scheduledLongLink) ||
    JSON.stringify(previous.scheduledThumbnailTrackingLink) !== JSON.stringify(tab.scheduledThumbnailTrackingLink)
  ) {
    task.steps.schedule = 'pending'
  }
  if (previous.firstPageFile[0]?.uid !== tab.firstPageFile[0]?.uid)
    task.steps.cover = tab.firstPageFile.length ? 'pending' : 'done'
  const contentChanged =
    previous.watermark !== tab.watermark ||
    previous.pdfURL !== tab.pdfURL ||
    previous.imagesURLPattern !== tab.imagesURLPattern ||
    previous.numberOfImages !== tab.numberOfImages ||
    previous.fileList.map(file => file.uid).join(',') !== tab.fileList.map(file => file.uid).join(',')
  if (contentChanged) {
    task.steps.upload = tab.fileList.length ? 'pending' : 'done'
    task.steps.generate = tab.fileList.length ? 'pending' : 'done'
    task.uploadAccepted = false
  }
}
